var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-container w-100 position-relative mb-5 pb-3"},[_c('span',{attrs:{"id":"ticket"}}),_vm._v(" "),(_vm.getMerchant().merchant_category_name == 'ACTIVITIES')?_c('ticket-activities'):_vm._e(),_vm._v(" "),(_vm.getMerchant().merchant_category_name == 'TRANSPORT')?_c('ticket-transport'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1cd9362","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ticket/TicketList.vue
// module id = null
// module chunks = 